var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 10H12c-.3 0-.6.3-.6.6 0 .2.1.3.2.4l5.2 5.2c.1.1.3.2.4.2.2 0 .4-.1.5-.3 1.3-1.5 2.1-3.4 2.2-5.4v-.1c.1-.3-.2-.6-.5-.6zM11.2 0c-.3 0-.5.2-.5.5v7.7c0 .3.2.6.5.6h7.7c.3 0 .5-.2.5-.6-.2-4.4-3.8-7.9-8.2-8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 16.9L9.9 11c-.1-.1-.2-.2-.2-.4V2.3c0-.3-.3-.6-.6-.6C4 1.9 0 5.9 0 10.8 0 15.9 4.3 20 9.7 20c2.4 0 4.7-.9 6.4-2.3.1-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMatrix);
export default __webpack_public_path__ + "static/media/risk-matrix.285f131c.svg";
export { ForwardRef as ReactComponent };